export const environment = {
  production: false,
  apiUrl: (window as Window & { __env?: { apiUrl?: string; appVersion?: string } }).__env?.apiUrl
    ?? 'https://api.dev.monkyja.com',
  appVersion: (window as Window & { __env?: { apiUrl?: string; appVersion?: string } }).__env?.appVersion
    ?? 'dev',
  /** Seed a known mDNS hostname for local dev/testing in Chrome (leave empty in prod). */
  devMdnsHostname: 'esp32-central-806599c857fc.local',
};
